import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  transform(text: string, length: number): string {
    if (length < 0) {
      throw new Error('Length should be greater than 0');
    }

    if (text.length <= length) {
      return text;
    }

    return text.slice(0, length - 3) + '...';
  }
}
